/** URL-safe alphabet with exactly 64 symbols, so `byte & 63` is unbiased. */
const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

/**
 * Random, URL-safe identifier. 12 symbols = 72 bits of entropy, plenty for ids that only need to be
 * unique inside one project document (project ids use 16).
 * Ids never start with `-` or `_` so they stay friendly in URLs and file names.
 */
export function uid(size = 12): string {
  const bytes = crypto.getRandomValues(new Uint8Array(size));
  let id = ALPHABET[bytes[0]! % 52]!;
  for (let i = 1; i < size; i++) id += ALPHABET[bytes[i]! & 63];
  return id;
}

export const projectId = () => uid(16);

export const now = () => Date.now();
